import { useFormMutation } from "@/hooks/useFormMutation";
import { sendData } from "@/services/api/fetcher";
import { unsubscribeWebPush } from "../webpush/api";
import {
  ForgoutPasswordPayload,
  LoginPayload,
  ResetPasswordPayload,
} from "./validation";
import { UseFormSetError } from "react-hook-form";

export const useLoginMutation = (setError: UseFormSetError<LoginPayload>) => {
  return useFormMutation<
    ApiResponse<DataObject<any>>,
    Error,
    LoginPayload,
    LoginPayload
  >({
    mutationFn: async (payload: LoginPayload) => {
      return await sendData("auth/login", payload, "POST");
    },
    loadingMessage: "Sedang login...",
    successMessage: "Login berhasil!",
    setError,
  });
};

export const useLogoutMutation = () => {
  return useFormMutation<ApiResponse<DataObject<null>>, Error, undefined>({
    mutationFn: async () => {
      // await unsubscribeWebPush();
      return await sendData("auth/logout", {}, "DELETE");
    },
    successMessage: "Berhasil Keluar",
  });
};

export const useForgoutMutation = () => {
  return useFormMutation<
    ApiResponse<DataObject<null>>,
    Error,
    ForgoutPasswordPayload
  >({
    mutationFn: async (payload) => {
      return await sendData("reset-password/verify-email", payload, "POST");
    },
    successMessage: "Berhasil Mengirimkan OTP",
  });
};

export const useVerificationOtpMutation = () => {
  return useFormMutation<
    ApiResponse<DataObject<{ token: string }>>,
    Error,
    { otp: string }
  >({
    mutationFn: async (payload) => {
      return await sendData("reset-password/verify-otp", payload, "POST");
    },
    successMessage: "Berhasil Memverifikasi OTP",
  });
};
export const useResetPasswordMutation = (token?: string) => {
  return useFormMutation<
    ApiResponse<DataObject<null>>,
    Error,
    ResetPasswordPayload
  >({
    mutationFn: async (payload) => {
      return await sendData(
        `reset-password/change-password?token=${token}`,
        payload,
        "PUT"
      );
    },
    successMessage: "Berhasil Reset Password",
  });
};
